import { Box, Modal, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { RewardData } from '../../context/context';

interface LeaderboardModalProps {
  open: boolean;
  onClose: () => void;
  rewardData: RewardData;
}

const truncateAddress = (address: string) => {
  if (address.length > 12) {
    return `${address.slice(0, 6)}...${address.slice(-6)}`;
  }
  return address;
};

const styles = {
  modal: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '90%', sm: '80%', md: '60%' },
    maxWidth: '800px',
    maxHeight: '80vh',
    bgcolor: '#011A2D',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    borderRadius: '1.5625rem',
    boxShadow: 24,
    p: 4,
    outline: 'none',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    mb: 3
  },
  title: {
    fontFamily: 'Outfit',
    fontWeight: 600,
    fontSize: '2rem',
    color: '#FFFFFF'
  },
  content: {
    overflowY: 'auto',
    flex: 1,
    '&::-webkit-scrollbar': {
      width: '0.4rem'
    },
    '&::-webkit-scrollbar-track': {
      background: 'rgba(255, 255, 255, 0.1)'
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'rgba(255, 255, 255, 0.2)',
      borderRadius: '0.2rem'
    }
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    py: 2,
    borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
  },
  text: {
    color: '#FFFFFF',
    fontSize: '1rem'
  }
};

export default function LeaderboardModal({ open, onClose, rewardData }: LeaderboardModalProps) {
  return (
    <Modal open={open} onClose={onClose} aria-labelledby="leaderboard-modal-title">
      <Box sx={styles.modal}>
        <Box sx={styles.header}>
          <Typography id="leaderboard-modal-title" sx={styles.title}>
            Leaderboard
          </Typography>
          <IconButton onClick={onClose} sx={{ color: 'white' }}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Box sx={styles.content}>
          {Object.entries(rewardData).map(([address, value], index) => (
            <Box key={address} sx={styles.row}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                <Typography sx={styles.text}>
                  {`${index + 1}. ${window.innerWidth < 600 ? truncateAddress(address) : address}`}
                </Typography>
                <Typography sx={[styles.text, { paddingRight: 2 }]}>{Math.floor(Number(value))}</Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Modal>
  );
}
